module.exports = __webpack_public_path__ + "static/media/our-eggs.ced8d7af.jpg";